import { Directive } from '@angular/core';
import { IWizard } from '@util/wizard';

@Directive()
export abstract class BaseWizard {
  wizard: IWizard<number>;

  nextStep() {
    this.wizard.currentStep++;
  }
  prevStep() {
    this.wizard.currentStep--;
  }
}
